import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NomidioValidators } from './validation';

@Injectable()
export class NomidioFormsService {
  /**
   * Get a form control used for OTP Controls.
   *
   * This form control has the following validators:
   * • required
   * • pattern (numeric only)
   * • exactLength
   *
   * @param initialValue The initial value of the control
   * @param codeLength The exact length of the OTP code
   * @returns A form control with all the validation required for OTP inputs
   */
  public getOtpControl(initialValue = '', codeLength = 6): FormControl<string> {
    return new FormControl<string>(initialValue, {
      nonNullable: true,
      validators: [
        Validators.required,
        Validators.pattern(/^\d*$/),
        NomidioValidators.exactLength(codeLength),
      ]
    });
  }
}
